import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=42a7b16b&scoped=true&"
import script from "./activityInfo.vue?vue&type=script&lang=js&"
export * from "./activityInfo.vue?vue&type=script&lang=js&"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=42a7b16b&lang=scss&scoped=true&"
import style1 from "./activityInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7b16b",
  null
  
)

export default component.exports